import React, { Component } from 'react';

class Visual extends Component {
  constructor (props) {
    super(props);

    this.state = {
      currentEventInfo: this.props.currentEventInfo
    };
  }

  alertPrize (indicatedSegment) {
    if (indicatedSegment.text === '기프티콘') {
      document.getElementsByClassName('re_popup_w_gifticon')[0].className = 're_popup_w_gifticon current';
    } else if (indicatedSegment.text === '포인트') {
      document.getElementsByClassName('re_popup_w_point')[0].className = 're_popup_w_point current';
    } else if (indicatedSegment.text === '꽝') {
      document.getElementsByClassName('re_popup_w_fail')[0].className = 're_popup_w_fail current';
    }
  }

  render () {
    const { bgImgUrlPc, promotionImgUrlPc, bgColorCodePc } = this.props.currentEventInfo ? this.props.currentEventInfo.eventInfo : {};
    const style = {
      backgroundColor: bgColorCodePc,
      backgroundImage: 'url(' + bgImgUrlPc + ')'
    };

    return (
      <div className='re_visual_w' style={style}>
        <h4 className='hide'>룰렛</h4>
        <div className='re_visual_roulette_w'>
          {/* calculatePrize(segmentNumber) 로 멈출 세그먼트를 스핀 전에 설정할 수 있습니다.
            * 이미 참여한 사람은 re_visual_roulette_button 클릭해도 애니메이션 없이 팝업창 re_popup_w_already 띄워주세요 */}
          <button className='re_visual_roulette_button' onClick={this.props.onCalculatePrize}>START</button>
          {/*  운영이미지 : 룰렛돌림판 (640x640 사이즈, 아래 스크립트의 loadedImg.src 에 이미지경로가 들어갑니다., 각 세그먼트 구분은 시계방향순서로 segments 배열에 저장하여 사용) */}
          <canvas id='canvas' width='640' height='640' className='re_visual_roulette_canvas' />
        </div>
        {/* 운영이미지 : 이달의 상품 (996x264 사이즈) */}
        <h5 className='hide'>이달의 상품</h5>
        <img className='re_visual_image_gift' src={promotionImgUrlPc} alt='이달의 상품 기프티콘 20명과 S포인트 100명' />
      </div>
    );
  }
}

export default Visual;
